export function PercentageMask(value: number | string, minFractionDigits: number, maxFractionDigits: number): string {
  let Value: number;

  if (!value) {
    return "Sem valor";
  } else {
    if (typeof value !== "number") {
      Value = parseFloat(value);
      if (Number.isNaN(Value)) {
        return "Sem valor";
      }
    } else {
      Value = value;
    }
  }

  return Value.toLocaleString("pt-BR", {
    style: "percent",
    minimumFractionDigits: minFractionDigits ? minFractionDigits : 2,
    maximumFractionDigits: maxFractionDigits ? maxFractionDigits : 4
  });
}



// WEBPACK FOOTER //
// ./src/util/Masks/PercentageMask.ts